import { assert } from '../app/logger.js';
import { navigation } from '../app/navigation.js';
import { PanelBase } from '../ui/panel_base.js';
import { UIQueueable } from '../ui/ui_queueable.js';

import '../controls/image_slider.js';

/**
 * Pictures gallery.
 */
class GalleryPanel extends PanelBase {
  static id = navigation.kGalleryPanelId;

  initialize() {
    super.initialize();

    this.classList.add('fixed');
    this.sliderElement.onchange = idx => (this.params.picidx = idx);
    this.sliderElement.onclose = UIQueueable(() => navigation.closeGallery());
  }

  static markup = `
    <image-slider></image-slider>
  `;

  static get selectors() {
    return Object.assign({}, super.selectors, {
      Slider: 'image-slider',
    });
  }

  static get elements() {
    return {
      sliderElement: this.selectors.Slider,
    };
  }

  get historyState() {
    return [
      {
        page: this.page,
        params: this.params,
      },
      `${this.params.title} - Gallery | CamperAid`,
      '',
    ];
  }

  switchOn(params) {
    assert(params, `[panel:switch][gallery:open] no params`);
    assert(params.title, `[panel:switch][gallery:open] no title`);
    assert(params.pics, `[panel:switch][gallery:open] no pics`);
    assert(
      params.picidx !== undefined,
      `[panel:switch][gallery:open] no picidx`
    );

    this.params = params;

    this.sliderElement.set(
      this.params.pics.map(pic => `/pic/${pic}`),
      this.params.picidx
    );

    super.switchOn();

    // Refresh the image slider navbar after the panel is shown.
    this.sliderElement.refresh();
    this.sliderElement.focus();
  }

  switchOff() {
    this.sliderElement.close();
    super.switchOff();
  }
}

navigation.registerPanel(GalleryPanel);

export { GalleryPanel };
